var map = {
	"./CMU Logo.png": 1822,
	"./DgAb-MXBFJSJK1wiyrxyqCXk.png": 7539,
	"./Harvard_University_coat_of_arms.svg.png": 2352,
	"./MIT-Logo.png": 3522,
	"./UCLA_Bruins_script.svg copy.png": 6696,
	"./University_of_Illinois_at_Urbana-Champaign_Wordmark.svg.png": 7698,
	"./caltech-logo-10B73E0D17-seeklogo.com.png": 7846,
	"./columbia-university.png": 3409,
	"./iu_1710905385_1.png": 4276,
	"./stanford-university-logo-97C549CD89-seeklogo.com.png": 2973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7104;